export const APP_NODE_ID = "app-root";
